import { useEffect } from 'react'

import { currentPageParams } from 'scrivito'

import { parseOrder, serializeOrder } from './orderParam'
import type { Order } from './orderParam'
import { TableSorter, TableSorterDirection } from '@/Components/Table'
import { writeUrlParams } from '@/hooks/useUrlParams'

export const useTableSorter = (defaultOrder?: Order) => {
  const orderRaw = currentPageParams()['order'] as string | null
  const orderParam = parseOrder(orderRaw)
  const order = orderParam ?? defaultOrder
  const sorter = orderToSorter(order)

  useEffect(() => {
    if (!orderRaw && defaultOrder) {
      writeUrlParams({ order: serializeOrder(defaultOrder) }, true)
    }
  }, [orderRaw, defaultOrder])

  const sortColumn = (accessor: string) => {
    const current =
      parseOrder(currentPageParams()['order'] as string | null) ?? defaultOrder
    const isAsc = current?.[0] !== accessor || current?.[1] === 'desc'
    writeUrlParams({
      order: serializeOrder([accessor, isAsc ? 'asc' : 'desc']),
    })
  }

  return { sorter, sortColumn }
}

const orderToSorter = (order: Order | undefined): TableSorter => {
  if (order) {
    const [accessor, direction] = order

    const isAsc = direction === 'asc'

    return {
      accessor,
      direction: isAsc ? TableSorterDirection.ASC : TableSorterDirection.DESC,
    }
  }
  return null
}
